export default {
  header: {
    title: 'Acheter une carte cadeau',
  },
  checkout_btn: {
    title: 'Paiement',
    max_quantity: 'Maximum {{max}} cartes cadeaux par achat',
  },
  items: {
    gift_card: {
      online: 'Carte cadeau utilisable en ligne uniquement',
      online_and_store: 'Carte cadeau (utilisable en ligne et en magasin)',
      title: 'Sélectionnez le montant souhaité',
      description: 'Ajoutez la carte cadeau avec la quantité souhaitée au panier',
    },
    expiration: {
      label: 'Valable 3 ans',
      title: 'Bonne idée cadeau !',
      description: 'Le bénéficiaire peut utiliser le bon librement dans les 3 ans.',
    },
    delivery: {
      label: 'Livraison immédiate en PDF par e-mail',
      title: 'Livraison instantanée en PDF par e-mail',
      description: 'Après paiement sécurisé, vous recevrez le bon immédiatement.',
    },
  },
  form: {
    value: {
      title: 'Choisissez le montant de la carte cadeau',
      custom: {
        label: 'Personnalisé',
        placeholder: 'Entrez un montant entre {{min}} et {{max}} {{currency}}',
      },
    },
    quantity: {
      title: 'Quantité',
    },
    email: {
      title: 'Quelle est votre adresse e-mail pour recevoir la carte cadeau ?',
      placeholder: 'Votre adresse e-mail',
      error: 'E-mail invalide',
    },
  },
  confirmation: {
    title: {
      title: 'Acheter une carte cadeau ?',
      subtitle_one: 'Souhaitez-vous acheter 1 carte cadeau pour {{value}} ?',
      subtitle_other: 'Souhaitez-vous acheter {{count}} cartes cadeaux pour {{value}} ?',
    },
    description: {
      total: 'Total :',
      email: 'E-mail :',
      quantity: 'Quantité',
      amount: 'Montant',
    },
    footer: {
      cancel: 'Annuler',
      confirm: 'Confirmer',
    },
  },
};
